// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__Ogp-9","avatar-input":"styles_avatar-input__WgRC0"};